import { render, staticRenderFns } from "./OnboardingPolicy.vue?vue&type=template&id=2d8097db&scoped=true&"
import script from "./OnboardingPolicy.vue?vue&type=script&lang=js&"
export * from "./OnboardingPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPolicy.vue?vue&type=style&index=0&id=2d8097db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8097db",
  null
  
)

export default component.exports